var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.26667 3.7H3.06667C1.9621 3.7 1.06667 4.59543 1.06667 5.7V14.5C1.06667 15.6046 1.9621 16.5 3.06667 16.5H10.8C11.9046 16.5 12.8 15.6046 12.8 14.5V13.3M14 13.3H6.26667C5.1621 13.3 4.26667 12.4046 4.26667 11.3V2.5C4.26667 1.39543 5.1621 0.5 6.26667 0.5H14C15.1046 0.5 16 1.39543 16 2.5V11.3C16 12.4046 15.1046 13.3 14 13.3Z",
    stroke: "#9D9DB0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copyIcon.b6c7adfb.svg";
export { ForwardRef as ReactComponent };